import React from 'react';
import StatusThumbHtmlView from './StatusHtml';
import StatusThumbReactView from './Status';
const StatusThumbView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(StatusThumbHtmlView, props);
    }
    return /*#__PURE__*/ React.createElement(StatusThumbReactView, props);
};
StatusThumbView.displayName = 'StatusThumbView';
export default StatusThumbView;
